<template>
    <IntegrationStoreSettingsLayout @save="saveAndContinue"
                                    @cancel="preventLeavingWithUnsavedChanges"
                                    :disable-save="!config.isDirty"
    >
        <!-- STORE ID -->
        <FormGroupNew :label="__('general.store_number')"
                      :description="__('actions.provide_thing', {thing: __('general.store_number')})"
                      :error="config.errors.es_store_id"
                      :required="requiredFields.includes('es_store_id')">
            <input type="number"
                   class="form-control"
                   v-model="config.es_store_id"
            >
        </FormGroupNew>
    </IntegrationStoreSettingsLayout>
</template>

<script>
import IntegrationStoreSettingsLayout from "@layouts/IntegrationStoreSettingsLayout.vue";
import IntegrationStoreConfigMixin from "@mixins/IntegrationStoreConfigMixin";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import IntegrationRoutesMixin from "@mixins/IntegrationRoutesMixin";

export default {
    components: {
        IntegrationStoreSettingsLayout,
        FormGroupNew,
    },

    mixins: [IntegrationStoreConfigMixin, IntegrationRoutesMixin]
}
</script>
